import { areaName, SelectionBladeState } from './types';

export const selectedItems = (state: any, key: string) =>
  (state[areaName] as SelectionBladeState)[key];
